import { Fragment, useContext } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { urlWithParams } from '../../../services/Util';

const StyledModal = styled.div`
	display: block;

	.modal-dialog {
		z-index: 1;
	}
	//
	// .btn-close {
	// 	margin: 0.618rem;
	// }
	//
	// .modal-body {
	// 	padding: 2rem 1rem 4rem;
	// }
	//
	.modal-backdrop {
		z-index: 0;
	}
`;

export default function Modal({ title, showClose = true, children }) {
	return (
		<StyledModal className="modal show">
			<div className="modal-dialog modal-lg" style={{ zIndex: 1 }}>
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">{title}</h5>
						{showClose && (
							<Link className="close" to={urlWithParams({ m: '' })}>
								&times;
							</Link>
						)}
					</div>
					<div className="modal-body">{children}</div>
				</div>
			</div>
			<div className="modal-backdrop fade show"></div>
		</StyledModal>
	);
}
